import React, {useState} from "react";
import moment from "moment";
import * as Item from "../../../booking/components/services/Item";
import { ArrowLongRightIcon } from "@heroicons/react/20/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import DeleteModal from "../../../shared/components/DeleteModal";
import {OrangeButton, WhiteButton} from "../../../shared/components/Buttons";

const CarTransportItem = ({ item, isActive, onSelect = null, onRemove = null, disabled, editable}) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    return <Item.Root
        isActive={isActive}
        disabled={disabled}
        Icon={
            <FontAwesomeIcon
                icon={faCar}
                className={"text-gray-700"}
                aria-hidden={true}
            />
        }
    >
        <Item.Heading>
            <Item.Title>
                <Item.Date date={moment(item.collectionDate)}/>
            </Item.Title>
            <Item.Subtitle>
                <Item.Place place={item.collectionPlace}/>
                <ArrowLongRightIcon className={"h-4 w-4"}/>
                <Item.Place place={item.depositPlace}/>
            </Item.Subtitle>
        </Item.Heading>
        <Item.Body>
            <div
                className={
                    "mr-8 flex items-center gap-4 lg:flex-col lg:justify-center lg:gap-0 lg:text-center"
                }
            >
                <Item.Info
                    number={item.vehicleCount}
                    icon={
                        <FontAwesomeIcon
                            icon={faCar}
                            className={"text-2xl text-gray-700"}
                            aria-hidden={true}
                        />
                    }
                />
            </div>
            <Item.FromTo from={item.collectionPlace} to={item.depositPlace}/>
            <div className={"space-y-4"}>
                <OrangeButton
                    disabled={disabled || !editable}
                    type="button"
                    className="!py-2 text-sm"
                    onClick={() => {onSelect && onSelect()}}
                >
                    {t("booking.modify")}
                </OrangeButton>
                <WhiteButton
                    disabled={disabled}
                    type="button"
                    onClick={() => {setOpen(true)}}
                >
                    {t("booking.delete")}
                </WhiteButton>
                <DeleteModal title="Êtes vous certain ?" open={open} setOpen={setOpen} onConfirm={onRemove}>
                    Vous allez supprimer un convoyage de véhicule.
                </DeleteModal>
            </div>
        </Item.Body>
    </Item.Root>
};
export default CarTransportItem;
